import { Label, WeatherIcon } from 'components'
import { t } from 'i18n'
import { If } from 'react-extras'
import { Weather } from 'store/ducks'
import { WeatherCardCol, WeatherCardContainer, WeatherCardRow } from './styled'

interface IWeatherProps {
  weather?: Weather
}

const WeatherCard = ({ weather }: IWeatherProps) => {
  return (
    <WeatherCardContainer>
      <WeatherCardRow>
        <WeatherCardCol>
          {/* <Label style={{ paddingBottom: 30, fontWeight: 'bold' }}>
            {t('temperature')}
          </Label> */}
          <Label style={{ marginRight: 20, fontSize: 42 }}>
            {weather?.temperature?.toFixed() ?? '-'}℃
          </Label>
        </WeatherCardCol>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          {/* <Label style={{ paddingBottom: 30, fontWeight: 'bold' }}>
            {t('weatherConditions')}
          </Label> */}
          <WeatherIcon
            widthImg="64px"
            heightImg="64px"
            marginImg="-10px 0 0 -8px"
            icon={
              (weather &&
                weather?.weatherInfo &&
                weather?.weatherInfo[0].icon) ||
              ''
            }
          />
          <Label>
            {weather?.weatherInfo && weather?.weatherInfo[0].description}
          </Label>
        </div>
      </WeatherCardRow>

      <If condition={!!weather?.comment}>
        <WeatherCardRow>
          <WeatherCardCol>
            <Label style={{ fontWeight: 'bold' }}>{t('comments')}</Label>
            <Label style={{ marginTop: 20, fontWeight: 'normal' }}>
              {weather?.comment}
            </Label>
          </WeatherCardCol>
        </WeatherCardRow>
      </If>
    </WeatherCardContainer>
  )
}

export { WeatherCard }
